module.exports = __webpack_public_path__ + "img/about-3.4970de77.png";